import { getCurrentUser } from "../auth/service";
import { FullStory } from "@fullstory/browser";
import axiosInstance from "../axios";

export const isInternalAccess = () =>
  !["app.boxs.in", "www.boxs.in", "app.boxs.lc", "boxs.lc"].includes(
    window.location.hostname
  );

export const setFullStoryIdentity = () => {
  const currentUser = getCurrentUser() || {};
  const isRobotAccess = navigator.userAgent.match(/bot/i) != null;

  // DISABLING since FS quote is over and this causes error to users.

  // if (
  //   !isRobotAccess &&
  //   !isInternalAccess() &&
  //   currentUser.id &&
  //   process.env.REACT_APP_ENVIRONMENT === "production" &&
  //   process.env.REACT_APP_FULL_STORY_ORG_ID
  // ) {
  //   FullStory("setIdentityAsync", {
  //     uid: currentUser.id,
  //     properties: {
  //       displayName: currentUser.name,
  //       mobile: currentUser.mobile,
  //       isGuestUser: currentUser.isFromLandingPage,
  //     },
  //   });
  // }
};

export const randomUUID = () => {
  if (typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  } else {
    const uuid = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
    return uuid;
  }
};

export const fetchOrganizationData = async (organizationId) => {
  // Using hard-coded access control since there isn't any plan based access as of now.
  return {
    add_projects: true,
    get_project_cutlist: false,
    get_optimization: false,
    get_bom_summary: false,
    get_item_cutlist: false,
    get_detailed_project_cl_view: false,
    get_material_options: true,
    pricing_mode: "module",
  };
};

export const fetchMaterials = async (type) => {
  return axiosInstance.get(`/materials_price?type=${type}&token=925b4b62202d`);
};

export const fetchTickets = async () => {
  return axiosInstance.get(`/tickets`);
};

export const addTicket = async ({ orderIdentifier, subject }) => {
  return axiosInstance.post("/tickets", {
    subject,
    order_identifier: orderIdentifier,
  });
};

export const updateTicket = async ({ id, key, value }) => {
  return axiosInstance.put(`/tickets/${id}`, {
    key,
    value,
  });
};

export const generateRequestUri = ({ url, params }) => {
  return axiosInstance.getUri({ url, params });
};

export const getAllOrgProjects = async () => {
  return axiosInstance.get(`/organizations`);
};
